import { ETransactionTypes } from 'constants/TransactionTypes';

export enum EState {
  OWNED = 'de37bdfc-069e-11ed-b939-0242ac120002',
  EXPORTED = 'de37c1e4-069e-11ed-b939-0242ac120002',
  ASSIGNED = 'de37c306-069e-11ed-b939-0242ac120002',
  LEASED = 'de37c428-069e-11ed-b939-0242ac120002',
  RECOVERED = 'de37c52c-069e-11ed-b939-0242ac120002',
  LOST = 'de37c63a-069e-11ed-b939-0242ac120002',
  SEIZED = 'de37c748-069e-11ed-b939-0242ac120002',
  DESTROYED = '95e3c28a-8ac8-11ee-b9d1-0242ac120002',
  DISABLED = '3a8da198-8abf-11ee-b9d1-0242ac120002',
  EXPIRED = '44725660-3ec4-436a-a1a3-621026fb526f',
  DEPLETED = '707980d8-8abf-11ee-b9d1-0242ac120002',
}

export const statesWithoutMovedTransaction = [
  EState.DESTROYED,
  EState.DISABLED,
  EState.EXPORTED,
  EState.LOST,
  EState.EXPIRED,
  EState.DEPLETED,
];

export const typesWithoutStrictAddressLocation = [
  ETransactionTypes.LOST,
  ETransactionTypes.STOLEN,
  ETransactionTypes.TEST_FIRED,
  ETransactionTypes.SPOT_CHECK,
];
